import { render, staticRenderFns } from "./Manuscript.vue?vue&type=template&id=264626d5&scoped=true"
import script from "./Manuscript.vue?vue&type=script&lang=js"
export * from "./Manuscript.vue?vue&type=script&lang=js"
import style0 from "./Manuscript.vue?vue&type=style&index=0&id=264626d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264626d5",
  null
  
)

export default component.exports